export const homeCGO: any = {
  logoBranding: 'platform/home/branding/cgo.png',
  logoBrandingAlt: 'platform/home/branding/Xpresate.jpeg',
  numeroImagenes: 19,
  rutaImagenes: 'platform/home/cgo/',
  filtroGris: true,
  tiempoLogoInicial: 10000
}
export const homeGPTW: any = {
  logoBranding: 'platform/home/branding/gptw.jpg',
  logoBrandingAlt: 'platform/home/branding/Xpresate.jpeg',
  numeroImagenes: 19,
  rutaImagenes: 'platform/home/cgo/',
  filtroGris: true,
  tiempoLogoInicial: 10000
}
export const homeIZZI: any = {
  logoBranding: 'platform/home/branding/gptw.jpg',
  logoBrandingAlt: 'platform/home/branding/Xpresate.jpeg',
  numeroImagenes: 17,
  rutaImagenes: 'platform/home/izzi/',
  filtroGris: false,
  tiempoLogoInicial: 10000
}
